module.exports = __webpack_public_path__ + "static/media/node.e89e75c5.png";